import get from 'lodash/get'
import request from '../request'
import { createAuthorization } from '../auth'

/**
 * Get terms from brooklyn
 */
export async function getPmTermData ({ auth, server, id }) {
  const res = await request
    .get(`${server}/term/${id}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .set('content-type', 'application/json')
  return get(res, 'body', {})
}
